import { z } from "zod";

import type { ValidationMessages } from "@citrine/utils/validation";

import { getBranchNameSchema } from "../branch";
import type { Metadata } from "../common";

interface BranchRootMetadata extends Metadata {
  readonly latest_branch_version?: {
    readonly id: string;
    readonly version: number;
  };
}

export const getBranchRootDataSchema = (props: ValidationMessages) =>
  z.object({
    name: getBranchNameSchema(props),
  });

export type BranchRootData = z.input<
  ReturnType<typeof getBranchRootDataSchema>
>;

export interface BranchRoot {
  id: string;
  data: BranchRootData;
  // I considered using the Readonly<> utility,
  // but annotating each field (especially when rendered red) is more obvious
  readonly metadata?: BranchRootMetadata;
}
